export default () => ({
	isOpen: false,
	shownView: 0,
	open() {
		if (!this.isOpen) {
			this.bodyScrollEnabled++;
		}
		this.isOpen = true;
	},
	close() {
		if (this.isOpen) {
			this.bodyScrollEnabled--;
		}
		this.isOpen = false;
		this.shownView = 0;
	},
});
